/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Assembly } from './Assembly';
import {
    AssemblyFromJSON,
    AssemblyFromJSONTyped,
    AssemblyToJSON,
} from './Assembly';
import type { ConstructorInfo } from './ConstructorInfo';
import {
    ConstructorInfoFromJSON,
    ConstructorInfoFromJSONTyped,
    ConstructorInfoToJSON,
} from './ConstructorInfo';
import type { CustomAttributeData } from './CustomAttributeData';
import {
    CustomAttributeDataFromJSON,
    CustomAttributeDataFromJSONTyped,
    CustomAttributeDataToJSON,
} from './CustomAttributeData';
import type { GenericParameterAttributes } from './GenericParameterAttributes';
import {
    GenericParameterAttributesFromJSON,
    GenericParameterAttributesFromJSONTyped,
    GenericParameterAttributesToJSON,
} from './GenericParameterAttributes';
import type { MemberTypes } from './MemberTypes';
import {
    MemberTypesFromJSON,
    MemberTypesFromJSONTyped,
    MemberTypesToJSON,
} from './MemberTypes';
import type { MethodBase } from './MethodBase';
import {
    MethodBaseFromJSON,
    MethodBaseFromJSONTyped,
    MethodBaseToJSON,
} from './MethodBase';
import type { Module } from './Module';
import {
    ModuleFromJSON,
    ModuleFromJSONTyped,
    ModuleToJSON,
} from './Module';
import type { RuntimeTypeHandle } from './RuntimeTypeHandle';
import {
    RuntimeTypeHandleFromJSON,
    RuntimeTypeHandleFromJSONTyped,
    RuntimeTypeHandleToJSON,
} from './RuntimeTypeHandle';
import type { StructLayoutAttribute } from './StructLayoutAttribute';
import {
    StructLayoutAttributeFromJSON,
    StructLayoutAttributeFromJSONTyped,
    StructLayoutAttributeToJSON,
} from './StructLayoutAttribute';
import type { TypeAttributes } from './TypeAttributes';
import {
    TypeAttributesFromJSON,
    TypeAttributesFromJSONTyped,
    TypeAttributesToJSON,
} from './TypeAttributes';

/**
 * 
 * @export
 * @interface Type
 */
export interface Type {
    /**
     * 
     * @type {string}
     * @memberof Type
     */
    readonly name?: string;
    /**
     * 
     * @type {Array<CustomAttributeData>}
     * @memberof Type
     */
    readonly customAttributes?: Array<CustomAttributeData>;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isCollectible?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Type
     */
    readonly metadataToken?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isInterface?: boolean;
    /**
     * 
     * @type {MemberTypes}
     * @memberof Type
     */
    memberType?: MemberTypes;
    /**
     * 
     * @type {string}
     * @memberof Type
     */
    readonly namespace?: string;
    /**
     * 
     * @type {string}
     * @memberof Type
     */
    readonly assemblyQualifiedName?: string;
    /**
     * 
     * @type {string}
     * @memberof Type
     */
    readonly fullName?: string;
    /**
     * 
     * @type {Assembly}
     * @memberof Type
     */
    assembly?: Assembly;
    /**
     * 
     * @type {Module}
     * @memberof Type
     */
    module?: Module;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isNested?: boolean;
    /**
     * 
     * @type {Type}
     * @memberof Type
     */
    declaringType?: Type;
    /**
     * 
     * @type {MethodBase}
     * @memberof Type
     */
    declaringMethod?: MethodBase;
    /**
     * 
     * @type {Type}
     * @memberof Type
     */
    reflectedType?: Type;
    /**
     * 
     * @type {Type}
     * @memberof Type
     */
    underlyingSystemType?: Type;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isTypeDefinition?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isArray?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isByRef?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isPointer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isConstructedGenericType?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isGenericParameter?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isGenericTypeParameter?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isGenericMethodParameter?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isGenericType?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isGenericTypeDefinition?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isSZArray?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isVariableBoundArray?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isByRefLike?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly hasElementType?: boolean;
    /**
     * 
     * @type {Array<Type>}
     * @memberof Type
     */
    readonly genericTypeArguments?: Array<Type>;
    /**
     * 
     * @type {number}
     * @memberof Type
     */
    readonly genericParameterPosition?: number;
    /**
     * 
     * @type {GenericParameterAttributes}
     * @memberof Type
     */
    genericParameterAttributes?: GenericParameterAttributes;
    /**
     * 
     * @type {TypeAttributes}
     * @memberof Type
     */
    attributes?: TypeAttributes;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isAbstract?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isImport?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isSealed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isSpecialName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isClass?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isNestedAssembly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isNestedFamANDAssem?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isNestedFamily?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isNestedFamORAssem?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isNestedPrivate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isNestedPublic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isNotPublic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isPublic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isAutoLayout?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isExplicitLayout?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isLayoutSequential?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isAnsiClass?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isAutoClass?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isUnicodeClass?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isCOMObject?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isContextful?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isEnum?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isMarshalByRef?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isPrimitive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isValueType?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isSignatureType?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isSecurityCritical?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isSecuritySafeCritical?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isSecurityTransparent?: boolean;
    /**
     * 
     * @type {StructLayoutAttribute}
     * @memberof Type
     */
    structLayoutAttribute?: StructLayoutAttribute;
    /**
     * 
     * @type {ConstructorInfo}
     * @memberof Type
     */
    typeInitializer?: ConstructorInfo;
    /**
     * 
     * @type {RuntimeTypeHandle}
     * @memberof Type
     */
    typeHandle?: RuntimeTypeHandle;
    /**
     * 
     * @type {string}
     * @memberof Type
     */
    readonly gUID?: string;
    /**
     * 
     * @type {Type}
     * @memberof Type
     */
    baseType?: Type;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isSerializable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly containsGenericParameters?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Type
     */
    readonly isVisible?: boolean;
}

/**
 * Check if a given object implements the Type interface.
 */
export function instanceOfType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TypeFromJSON(json: any): Type {
    return TypeFromJSONTyped(json, false);
}

export function TypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Type {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'customAttributes': !exists(json, 'CustomAttributes') ? undefined : ((json['CustomAttributes'] as Array<any>).map(CustomAttributeDataFromJSON)),
        'isCollectible': !exists(json, 'IsCollectible') ? undefined : json['IsCollectible'],
        'metadataToken': !exists(json, 'MetadataToken') ? undefined : json['MetadataToken'],
        'isInterface': !exists(json, 'IsInterface') ? undefined : json['IsInterface'],
        'memberType': !exists(json, 'MemberType') ? undefined : MemberTypesFromJSON(json['MemberType']),
        'namespace': !exists(json, 'Namespace') ? undefined : json['Namespace'],
        'assemblyQualifiedName': !exists(json, 'AssemblyQualifiedName') ? undefined : json['AssemblyQualifiedName'],
        'fullName': !exists(json, 'FullName') ? undefined : json['FullName'],
        'assembly': !exists(json, 'Assembly') ? undefined : AssemblyFromJSON(json['Assembly']),
        'module': !exists(json, 'Module') ? undefined : ModuleFromJSON(json['Module']),
        'isNested': !exists(json, 'IsNested') ? undefined : json['IsNested'],
        'declaringType': !exists(json, 'DeclaringType') ? undefined : TypeFromJSON(json['DeclaringType']),
        'declaringMethod': !exists(json, 'DeclaringMethod') ? undefined : MethodBaseFromJSON(json['DeclaringMethod']),
        'reflectedType': !exists(json, 'ReflectedType') ? undefined : TypeFromJSON(json['ReflectedType']),
        'underlyingSystemType': !exists(json, 'UnderlyingSystemType') ? undefined : TypeFromJSON(json['UnderlyingSystemType']),
        'isTypeDefinition': !exists(json, 'IsTypeDefinition') ? undefined : json['IsTypeDefinition'],
        'isArray': !exists(json, 'IsArray') ? undefined : json['IsArray'],
        'isByRef': !exists(json, 'IsByRef') ? undefined : json['IsByRef'],
        'isPointer': !exists(json, 'IsPointer') ? undefined : json['IsPointer'],
        'isConstructedGenericType': !exists(json, 'IsConstructedGenericType') ? undefined : json['IsConstructedGenericType'],
        'isGenericParameter': !exists(json, 'IsGenericParameter') ? undefined : json['IsGenericParameter'],
        'isGenericTypeParameter': !exists(json, 'IsGenericTypeParameter') ? undefined : json['IsGenericTypeParameter'],
        'isGenericMethodParameter': !exists(json, 'IsGenericMethodParameter') ? undefined : json['IsGenericMethodParameter'],
        'isGenericType': !exists(json, 'IsGenericType') ? undefined : json['IsGenericType'],
        'isGenericTypeDefinition': !exists(json, 'IsGenericTypeDefinition') ? undefined : json['IsGenericTypeDefinition'],
        'isSZArray': !exists(json, 'IsSZArray') ? undefined : json['IsSZArray'],
        'isVariableBoundArray': !exists(json, 'IsVariableBoundArray') ? undefined : json['IsVariableBoundArray'],
        'isByRefLike': !exists(json, 'IsByRefLike') ? undefined : json['IsByRefLike'],
        'hasElementType': !exists(json, 'HasElementType') ? undefined : json['HasElementType'],
        'genericTypeArguments': !exists(json, 'GenericTypeArguments') ? undefined : ((json['GenericTypeArguments'] as Array<any>).map(TypeFromJSON)),
        'genericParameterPosition': !exists(json, 'GenericParameterPosition') ? undefined : json['GenericParameterPosition'],
        'genericParameterAttributes': !exists(json, 'GenericParameterAttributes') ? undefined : GenericParameterAttributesFromJSON(json['GenericParameterAttributes']),
        'attributes': !exists(json, 'Attributes') ? undefined : TypeAttributesFromJSON(json['Attributes']),
        'isAbstract': !exists(json, 'IsAbstract') ? undefined : json['IsAbstract'],
        'isImport': !exists(json, 'IsImport') ? undefined : json['IsImport'],
        'isSealed': !exists(json, 'IsSealed') ? undefined : json['IsSealed'],
        'isSpecialName': !exists(json, 'IsSpecialName') ? undefined : json['IsSpecialName'],
        'isClass': !exists(json, 'IsClass') ? undefined : json['IsClass'],
        'isNestedAssembly': !exists(json, 'IsNestedAssembly') ? undefined : json['IsNestedAssembly'],
        'isNestedFamANDAssem': !exists(json, 'IsNestedFamANDAssem') ? undefined : json['IsNestedFamANDAssem'],
        'isNestedFamily': !exists(json, 'IsNestedFamily') ? undefined : json['IsNestedFamily'],
        'isNestedFamORAssem': !exists(json, 'IsNestedFamORAssem') ? undefined : json['IsNestedFamORAssem'],
        'isNestedPrivate': !exists(json, 'IsNestedPrivate') ? undefined : json['IsNestedPrivate'],
        'isNestedPublic': !exists(json, 'IsNestedPublic') ? undefined : json['IsNestedPublic'],
        'isNotPublic': !exists(json, 'IsNotPublic') ? undefined : json['IsNotPublic'],
        'isPublic': !exists(json, 'IsPublic') ? undefined : json['IsPublic'],
        'isAutoLayout': !exists(json, 'IsAutoLayout') ? undefined : json['IsAutoLayout'],
        'isExplicitLayout': !exists(json, 'IsExplicitLayout') ? undefined : json['IsExplicitLayout'],
        'isLayoutSequential': !exists(json, 'IsLayoutSequential') ? undefined : json['IsLayoutSequential'],
        'isAnsiClass': !exists(json, 'IsAnsiClass') ? undefined : json['IsAnsiClass'],
        'isAutoClass': !exists(json, 'IsAutoClass') ? undefined : json['IsAutoClass'],
        'isUnicodeClass': !exists(json, 'IsUnicodeClass') ? undefined : json['IsUnicodeClass'],
        'isCOMObject': !exists(json, 'IsCOMObject') ? undefined : json['IsCOMObject'],
        'isContextful': !exists(json, 'IsContextful') ? undefined : json['IsContextful'],
        'isEnum': !exists(json, 'IsEnum') ? undefined : json['IsEnum'],
        'isMarshalByRef': !exists(json, 'IsMarshalByRef') ? undefined : json['IsMarshalByRef'],
        'isPrimitive': !exists(json, 'IsPrimitive') ? undefined : json['IsPrimitive'],
        'isValueType': !exists(json, 'IsValueType') ? undefined : json['IsValueType'],
        'isSignatureType': !exists(json, 'IsSignatureType') ? undefined : json['IsSignatureType'],
        'isSecurityCritical': !exists(json, 'IsSecurityCritical') ? undefined : json['IsSecurityCritical'],
        'isSecuritySafeCritical': !exists(json, 'IsSecuritySafeCritical') ? undefined : json['IsSecuritySafeCritical'],
        'isSecurityTransparent': !exists(json, 'IsSecurityTransparent') ? undefined : json['IsSecurityTransparent'],
        'structLayoutAttribute': !exists(json, 'StructLayoutAttribute') ? undefined : StructLayoutAttributeFromJSON(json['StructLayoutAttribute']),
        'typeInitializer': !exists(json, 'TypeInitializer') ? undefined : ConstructorInfoFromJSON(json['TypeInitializer']),
        'typeHandle': !exists(json, 'TypeHandle') ? undefined : RuntimeTypeHandleFromJSON(json['TypeHandle']),
        'gUID': !exists(json, 'GUID') ? undefined : json['GUID'],
        'baseType': !exists(json, 'BaseType') ? undefined : TypeFromJSON(json['BaseType']),
        'isSerializable': !exists(json, 'IsSerializable') ? undefined : json['IsSerializable'],
        'containsGenericParameters': !exists(json, 'ContainsGenericParameters') ? undefined : json['ContainsGenericParameters'],
        'isVisible': !exists(json, 'IsVisible') ? undefined : json['IsVisible'],
    };
}

export function TypeToJSON(value?: Type | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'MemberType': MemberTypesToJSON(value.memberType),
        'Assembly': AssemblyToJSON(value.assembly),
        'Module': ModuleToJSON(value.module),
        'DeclaringType': TypeToJSON(value.declaringType),
        'DeclaringMethod': MethodBaseToJSON(value.declaringMethod),
        'ReflectedType': TypeToJSON(value.reflectedType),
        'UnderlyingSystemType': TypeToJSON(value.underlyingSystemType),
        'GenericParameterAttributes': GenericParameterAttributesToJSON(value.genericParameterAttributes),
        'Attributes': TypeAttributesToJSON(value.attributes),
        'StructLayoutAttribute': StructLayoutAttributeToJSON(value.structLayoutAttribute),
        'TypeInitializer': ConstructorInfoToJSON(value.typeInitializer),
        'TypeHandle': RuntimeTypeHandleToJSON(value.typeHandle),
        'BaseType': TypeToJSON(value.baseType),
    };
}

